export default "__VITE_ASSET__50Z0kuLn__"